import axios from "axios";
import store from "@/store";
import router from "@/router";
import { getAccessToken, removeAccessToken } from "@/utils/auth";

// create an axios instance

let HOST = process.env.HOST;
let requestUrl = "";
switch (HOST) {
  case "dev":
    // requestUrl = "http://admin.weixiao.test.weiguyun.com/api/";
    requestUrl = "http://admin.feedback.test.ct-study.com.cn/api/";
    // requestUrl = "https://admin.weixiao.ct-study.com.cn/api/";
    break;
  case "prod":
    requestUrl = "https://admin.weixiao.ct-study.com.cn/api/";
    break;
  case "test":
    requestUrl = "http://admin.weixiao.test.weiguyun.com/api/";
    break;
}

const service = axios.create({
  baseURL: requestUrl, // api的base_url
  timeout: 10000 // request timeout
});
let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = config => {
  for (let p in pending) {
    if (pending[p].u === config.url + "&" + config.method) {
      //当当前请求在数组中存在时执行函数体
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //把这条记录从数组中移除
    }
  }
};
let deleteAllPending = config => {
  for (let p in pending) {
    pending[p].f(); //执行取消操作
  }
  pending = [];
};

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    config.cancelToken = new cancelToken(c => {
      pending.push({ u: config.url + "&" + config.method, f: c }); // 这里的ajax标识是用请求地址&请求方式拼接的字符串
    });
    if (getAccessToken()) {
      config.headers["Authorization"] = "Bearer " + getAccessToken();
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone interceptor
service.interceptors.response.use(
  response => {
    removePending(response.config); //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    return response;
  },
  error => {
    if (error.response.status == 401) {
      deleteAllPending();
      removeAccessToken();
      router.go(0);
      return new Promise(() => {});
    } else {
      return Promise.reject(error);
    }
  }
);

export default service;

// WEBPACK FOOTER //
// ./src/utils/request.js



// WEBPACK FOOTER //
// ./src/utils/request.js